import { QuickTable, QuickTableFilterTabs } from "../../components";
import { virtualAccountTransferRefundsDisplayFormatter } from "./virtualAccountTransferRefundsDisplayFormatter";
import {
  IViewProps,
  VIRTUAL_ACCOUNT_TRANSFER_LIST_TABLE_NAME,
} from "./VirtualAccountTransferRefunds";
import { VirtualAccountTransferRefundDetailsModal } from "./DetailsModal";
import { Route, Routes } from "react-router-dom";

export const View = (props: IViewProps) => {
  return (
    <div className="virtual-account-transfer-refunds-page">
      <QuickTable
        id={VIRTUAL_ACCOUNT_TRANSFER_LIST_TABLE_NAME}
        prefixFiltersWithId
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        // renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
            filterPrefix={VIRTUAL_ACCOUNT_TRANSFER_LIST_TABLE_NAME}
          />
        }
        displayFormatter={virtualAccountTransferRefundsDisplayFormatter}
        onExport={props.onExport}
        disableClickOnTargetClassNames={["copy-btn", "transaction-id-text"]}
        openDetailsModal={props.openDetailsModal}
      />

      <Routes>
        <Route
          path=":id/details"
          element={<VirtualAccountTransferRefundDetailsModal />}
        />
      </Routes>
    </div>
  );
};
